(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
    const input = root.querySelector('[data-variant-input]');
    const selectors = [...root.querySelectorAll('[data-option-position]')];
    const buy = root.querySelector('[data-buy]');
    const mainImage = root.querySelector('.hp-main-image');
    const label = (raw) => {
      let value = raw.split(' — ')[0].split('+CHF')[0].trim();
      const translations = {'Black': labels.black, 'Silver': labels.silver, 'Schwarz': labels.black, 'Silber': labels.silver, 'Hibox only (without levers)': labels.without, 'without clamp': labels.without_clamp, 'with universal clamp': labels.with_clamp, 'Hibox Trigger': labels.with_trigger, 'Hibox Trigger with universal Clamp': labels.with_trigger_clamp, 'Gebla Shimkit A21 (till 2021)': labels.a21, 'Gebla Shimkit A22 (from 2022)': labels.a22};
      return translations[value] || value.replace('(mechanic disc/rim-break)', `(${labels.mechanical})`).replaceAll(' with ', ` ${labels.with} `);
    };
    selectors.forEach((select, position) => [...select.options].forEach((option) => {
      const matching = variants.filter((variant) => variant.options[position] === option.value);
      const prices = [...new Set(matching.map((variant) => variant.price))];
      option.textContent = label(option.value) + (position === 0 && prices.length === 1 ? ` · ${prices[0]}` : '');
    }));
    const initial = variants.find((variant) => String(variant.id) === input.value);
    if (!initial) return;
    selectors.forEach((select, position) => { select.value = initial.options[position]; });
    const update = () => {
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selectors[index].value));
      buy.disabled = !variant?.available;
      buy.firstChild.textContent = !variant?.available ? labels.sold_out : variant.preorder ? labels.preorder : labels.buy;
      root.querySelector('[data-availability]').textContent = !variant?.available ? labels.unavailable : variant.preorder ? labels.preorder_note : labels.ready;
      input.value = variant ? String(variant.id) : '';
      root.querySelectorAll('[data-price]').forEach((element) => { element.textContent = variant ? variant.price : '—'; });
      selectors.forEach((select, position) => [...select.options].forEach((option) => {
        option.disabled = !variants.some((candidate) => candidate.available && candidate.options[position] === option.value && candidate.options.every((value, index) => index >= position || value === selectors[index].value));
      }));
      if (!variant) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url);
      if (variant.image) {
        mainImage.removeAttribute('srcset');
        mainImage.src = variant.image;
      }
    };
    selectors.forEach((select) => select.addEventListener('change', update));
    root.querySelector('[data-option-pickers]').hidden = false;
    root.querySelector('[data-fallback-picker]').hidden = true;
    root.querySelector('.hp-form').addEventListener('submit', (event) => {
      const selected = variants.find((variant) => String(variant.id) === input.value);
      if (!selected?.available) event.preventDefault();
    });
    root.querySelectorAll('[data-image]').forEach((button) => button.addEventListener('click', () => {
      mainImage.removeAttribute('srcset');
      mainImage.src = button.dataset.image;
      mainImage.alt = button.dataset.alt;
      root.querySelectorAll('[data-image]').forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
    }));
    const sticky = root.querySelector('[data-sticky]');
    const hero = root.querySelector('.hp-hero');
    new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, {threshold: 0}).observe(hero);
    update();
    root.dataset.initialized = 'true';
  };
  document.querySelectorAll('[data-hibox-product]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-hibox-product]').forEach(init));
})();
